import { render, staticRenderFns } from "./jiankangInner.vue?vue&type=template&id=1dea417a&scoped=true&"
import script from "./jiankangInner.vue?vue&type=script&lang=js&"
export * from "./jiankangInner.vue?vue&type=script&lang=js&"
import style0 from "./jiankangInner.vue?vue&type=style&index=0&id=1dea417a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea417a",
  null
  
)

export default component.exports